import { render, staticRenderFns } from "./Expeditions.vue?vue&type=template&id=99c8d62a"
import script from "./Expeditions.vue?vue&type=script&lang=js"
export * from "./Expeditions.vue?vue&type=script&lang=js"
import style0 from "./css/expeditions.css?vue&type=style&index=0&prod&scope=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports